import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { AnticipationResult } from "slotworks/model/gameplay/records/results/anticipation-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";

export class DMFCollectAnticipationSupplement implements DataProcessorSupplement {
    public active: boolean;

    public process(record: SpinRecord) {
        if (!(record instanceof FreespinRecord)) {
            record.getResultsOfType(AnticipationResult).forEach((result: AnticipationResult) => {
                for (let reelIndex: number = 0; reelIndex < result.anticipateSymbols.length; reelIndex++) {
                    const fsAntic: boolean = result.anticipateSymbols[reelIndex].indexOf("S") > -1;
                    if (!fsAntic) {
                        result.reelAnticipations[reelIndex] = false;
                        result.anticipateSymbols[reelIndex].filter((sym: string) => !(/^QH/.test(sym)) );
                    }
                }
            });
        }
    }
}
